import React, { useState } from 'react';
//import './navbar.css';
//import { Link } from "react-router-dom"
import { Dropdown, Modal} from 'react-bootstrap';
import Progetto_valutazione_form_base from "./Progetto_valutazione_form_base.jsx";


const Valutazione_progetto = (props) => {
//    const [somma, calcola_somma] = useState('');
    const [show, setShow] = useState(false);

  
    return (
    <>
        <Dropdown.Item onClick={() => setShow(true)} >Valutazione progetto </Dropdown.Item>
    
        <Modal
            show={show}
            size="lg"
            onHide={() => setShow(false)}
            backdrop="static"
            keyboard={false}
        >
        <Modal.Header closeButton>
                <Modal.Title id="example-custom-modal-styling-title">

                </Modal.Title>
        </Modal.Header>
         <Modal.Body>
                <Progetto_valutazione_form_base progetto={props.progetto}     setShow={setShow} />

        </Modal.Body>
        </Modal>      
    </>

    )
}
export default Valutazione_progetto;